exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2PWDLrhAavftGcnm2zSTnC{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}._2ED3NDFbbpNQF3qo-VwYZm{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;white-space:nowrap;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}html[dir=ltr] ._2ED3NDFbbpNQF3qo-VwYZm:first-of-type{margin-right:5px}html[dir=ltr] ._2ED3NDFbbpNQF3qo-VwYZm:last-of-type,html[dir=rtl] ._2ED3NDFbbpNQF3qo-VwYZm:first-of-type{margin-left:5px}html[dir=rtl] ._2ED3NDFbbpNQF3qo-VwYZm:last-of-type{margin-right:5px}", ""]);

// exports
exports.locals = {
	"buttonContainer": "_2PWDLrhAavftGcnm2zSTnC",
	"button": "_2ED3NDFbbpNQF3qo-VwYZm"
};